export default __webpack_public_path__ + "static/media/man-unanswered.a007db70.svg";